import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to top when route changes
 * Place this inside the Router but outside Routes
 */
const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll window to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    // Also scroll admin content area if it exists
    const adminContent = document.querySelector('.admin-content');
    if (adminContent) {
      adminContent.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }

    // Also scroll any other scrollable containers
    const scrollableContainers = document.querySelectorAll('.cms-content, .content-area');
    scrollableContainers.forEach(container => {
      if (container instanceof HTMLElement) {
        container.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;